import { useEffect, useState, useContext, useRef} from 'react'
import {  Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { GiSandsOfTime } from "react-icons/gi";

import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import { Img, Tasks } from "../components/Elements";

import './css/MoeLogin.css'
import { Config } from '../inc/Config';
import { IoCheckmarkDoneOutline } from 'react-icons/io5';
import { MdOutlineErrorOutline } from 'react-icons/md';



export default function MoeLogin() {

    const testRes = {
        
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": [
            "0040503815"
        ],
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname": [
            "חמזה"
        ],
        "http://schemas.education.gov.il/ws/2015/01/identity/claims/orgrolecomplex": [
            "667[mosad:219451]",
            "738[mosad:219451]",
            "748[taagid:40503815]"
        ],
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname": [
            "חג'אזי"
        ],
        "http://schemas.education.gov.il/ws/2015/01/identity/claims/zehut": [
            "040503815"
        ],
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/displayname": [
            "חמזה חג'אזי"
        ],
        "http://schemas.education.gov.il/ws/2015/01/identity/claims/orgrolessimple": [
            "667,738,748"
        ],
        "http://schemas.education.gov.il/ws/2015/01/identity/claims/orgrolesyeshuyot": [
            "219451,219451,40503815"
        ],
        "http://schemas.education.gov.il/ws/2015/01/identity/claims/isstudent": [
            "No"
        ]
    }

    // const testRes = {
    //     "http://schemas.education.gov.il/ws/2015/01/identity/claims/studentmakbila": [
    //         "5"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/shempratikinui": [
    //         "زينه"
    //     ],
    //     "http://schemas.education.gov.il/ws/2015/01/identity/claims/studentmosad": [
    //         "219451"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/displaynamekinui": [
    //         "زينه مصطفى"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": [
    //         "0337434179"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname": [
    //         "זינה"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/shemmishpachakinui": [
    //         "مصطفى"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname": [
    //         "מוסטפא"
    //     ],
    //     "http://schemas.education.gov.il/ws/2015/01/identity/claims/zehut": [
    //         "337434179"
    //     ],
    //     "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/displayname": [
    //         "זינה מוסטפא"
    //     ],
    //     "http://schemas.education.gov.il/ws/2015/01/identity/claims/studentkita": [
    //         "7"
    //     ],
    //     "http://schemas.education.gov.il/ws/2015/01/identity/claims/isstudent": [
    //         "Yes"
    //     ]
    // }

    const { t } = useTranslation();

    const { userData } = useContext(AppContext); 
	const [userinfo, setuserinfo] = userData;

    const [loading, setloading] = useState(true);
    const [error, seterror] = useState(false);
    const [results, setresults] = useState({});
    const [data, setdata] = useState({});

    async function validateUser(data) {

        Fetch("moe_login", (d) => {
            
            if (d?.error) {
                seterror(d?.error);
            } else {
                setresults(d);

                setTimeout(() => {
                    window.location="/";
                }, 3000);
            }
        }, data);
    }

    async function getData() {
        
        let allData = {};
        if (process.env.NODE_ENV == "development") {
            allData = testRes;

        } else {
            
            let res = await fetch(Config.php + `/getAttributes.php`);
            let json = await res?.json();

            console.log(json);
            
            
            allData = json;

        }
        
        setloading(false);

        if (allData['http://schemas.education.gov.il/ws/2015/01/identity/claims/isstudent']) {
            validateUser(allData);
        } else {
            seterror("all");
        }

    }

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 2000);
    }, []);

    

    if (loading) {
        return (
            <>
                <Loader />
                <div className='moeLoginBoxNew'>

                    <div className='insideBox'>
                        <GiSandsOfTime />
                        <h1>{t("wait")}..</h1>
                        <p>{t("error",  { returnObjects: true })[33]}</p>
                        
                    </div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <div className='moeLoginBoxNew'>

                    <div className='insideBox'>
                        <MdOutlineErrorOutline />
                        <h1>{t("sorry")}</h1>
                        <p>{t("error",  { returnObjects: true })[error]} {t("way")}<b>0507770313</b></p>
                        <a className='btn' style={{marginTop:20,}} href='/simplesaml/sp_logout.php'>{t("return_btn")}</a>
                    </div>
                </div>
            </>
        );
    }

    if (results?._id) {

        return (
            <>
                
                <div className='moeLoginBoxNew'>
    
                    <div className='insideBox'>
                        <IoCheckmarkDoneOutline style={{color:"green"}} />
                        <h1>{t("wow")}</h1>
                        <p>{t("error",  { returnObjects: true })[32]}</p>
                    </div>
                </div>
    
            </>
        )
    }
}
